import { useState } from 'react';

//components
import {AddInputPanelWithTags, BasicButton} from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';

//interfaces
import { IWhitelistData } from  '@/interfaces/passkeys';

//styling
import "../../../../../css/global/Modals/whitelist-modal.scss";



const WhitelistAddressModal = ({showModal, hideModal, onAddAddress, onRemoveClick, whitelistData} : {showModal: boolean, hideModal: () => void, onAddAddress: (address: string)=>void, onRemoveClick: (addressId: number)=>void, whitelistData: IWhitelistData[]}) => {
    const [textString, setTextString] = useState<string>("");
    const whitelistAddresses: { title: string; id: number }[] =
        whitelistData.map(({ id, ipAddress }) => ({ id, title: ipAddress }));
        
    return (
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="whitelist-address-modal" 
            isFullPage
        >
                <div className="whitelist-address-modal-content">
                     <h1 className='header-text'>Restrict Recovery Access</h1> 
            
                    <div className="whitelist-explainer-text">
                        Add trusted IP addresses to control where recovery attempts can be made and protect against unauthorised access.
                    </div>

                    <AddInputPanelWithTags
                        onRemoveItem={onRemoveClick}
                        list={whitelistAddresses}
                        textString={textString} 
                        setTextString={setTextString} 
                        onAddTextClick={() => {onAddAddress(textString), setTextString("")}} 
                        inputPlaceholder={'E.g. 192.168.0.1'}
                    />

                    <div className='modal-button-panel'>
                        <BasicButton 
                            content={"Done"}  
                            className={`confirm-button thrive-navy-style`}  
                            ariaLabel={'Close Modal'} 
                            onButtonClick={hideModal}
                        />
                    </div>
                </div>
        </ModalWrapper> 
    );  
}

export default WhitelistAddressModal;
